import QrDashboard from "../components/QrDashboard";

export default function QrDashboardPage() {
  return <QrDashboard />;
}
